import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

const EmbedeSuporteComponent = ({ width = "60vw", height = "400px" }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        style={{
          width: "auto",
          height: "4em",
          whiteSpace: "nowrap",
          padding: "0 16px",
          flexShrink: 0,
        }}
        variant="outlined"
        onClick={() => setOpen(true)}
        startIcon={<HelpOutlineOutlinedIcon />}
      >
        AJUDA E SUPORTE
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        fullScreen={false}
        maxWidth="xl"
        PaperProps={{ style: { width, height: "90vh", maxWidth: "70vw" } }}
      >
        <DialogTitle>
          AJUDA E SUPORTE
          <IconButton
            onClick={() => setOpen(false)}
            style={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          style={{ padding: 0, height: "100%", overflow: "hidden" }}
        >
          <iframe
            title="Suporte CreditOn"
            src="https://app.pipefy.com/public/form/RXw-EiWN?embedded=true"
            style={{ border: "none", width: "100%", height: "100%" }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
export default EmbedeSuporteComponent;
